export default __webpack_public_path__ + "static/media/view2.d7f82d44.webp";